import { render, staticRenderFns } from "./DialogAutorizaDevolucao.vue?vue&type=template&id=2f45de9a&scoped=true"
import script from "./DialogAutorizaDevolucao.vue?vue&type=script&lang=js"
export * from "./DialogAutorizaDevolucao.vue?vue&type=script&lang=js"
import style0 from "./DialogAutorizaDevolucao.vue?vue&type=style&index=0&id=2f45de9a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f45de9a",
  null
  
)

export default component.exports